package one.healthium.log_food.ui.scan_results

sealed interface ScanResultsEvent {
    data object FoodAdded : ScanResultsEvent
}
